import {
  orangeShades,
  primaryColors,
  transparentColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

export const alertStyles = {
  padding: '0.125rem 0.5rem 0.125rem 0.375rem',
  display: 'flex',
  boxSizing: 'border-box',
  alignItems: 'center',
  borderRadius: '0.125rem',
  gap: '0.5rem',
  marginBottom: '0.25rem',
  backgroundColor: transparentColors.blackShade3,
  '.MuiAlert-action': {
    marginRight: '0',
    padding: '0'
  },

  '.MuiAlert-icon': {
    padding: 0,
    margin: 0,
    alignSelf: 'flex-start',
    paddingTop: '0.125rem'
  },
  '&.MuiAlert-colorInfo': {
    borderLeft: `0.25rem solid ${whiteShades.shade1}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorError': {
    borderLeft: `0.25rem solid ${primaryColors.orange}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorSuccess': {
    borderLeft: `0.25rem solid ${primaryColors.white}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorWarning': {
    borderLeft: `0.25rem solid ${orangeShades.shade1}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '.MuiAlert-message': {
    padding: 0,
    textAlign: 'center',
    height: 'fit-content',
    marginRight: '0.5rem'
  }
}
